import { render } from "./MemberDashboardLayout.vue?vue&type=template&id=0fccbf8b&scoped=true"
import script from "./MemberDashboardLayout.vue?vue&type=script&lang=js"
export * from "./MemberDashboardLayout.vue?vue&type=script&lang=js"

import "./MemberDashboardLayout.vue?vue&type=style&index=0&id=0fccbf8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fccbf8b"]])

export default __exports__